export default __webpack_public_path__ + "static/media/04.0c59b551.png";